export default __webpack_public_path__ + "static/media/connect-light.030b9a31.webp";